import { pictures } from '@shared/serializers/pictures.serializer';
import { getSerializer } from '@shared/serializers/serializer';
import { assetsCategory } from './assets-category.serializer';

export const users = {
  type: 'user',
  attributes: [
    'firstName',
    'lastName',
    'picture',
    'email',
    'phone',
    'countryCode',
    'password',
    'role',
    'isActive',
    'verifiedCreated',
    'resetToken',
    'resetExpires',
    'connectedAt',
    'createdAt',
    'updatedAt',
    'language',
    'categories',
    'captcha',
    'isNewPasswordChecked'
  ],
  categories: {
    ref: 'id',
    attributes: assetsCategory.attributes,
    included: false
  },
  picture: {
    ref: 'id',
    attributes: pictures.attributes,
    included: false
  }
};

export const UsersSerializer = getSerializer(users);
